import React, { useMemo, useState } from 'react';
import { StyledDiv } from '../../Theme/CommonStyled';
import SearchInput from '../Common/SearchInput';
import useLandingStore from '../../Store/Landing';
import ListItem from './ListItem';
import useContactUsStore from '../../Store/contactUs';

const Branches: React.FC = () => {
  const landingData = useLandingStore((state) => state.landingData);
  const contactUsData = useContactUsStore((state) => state.contactUsData);
  const [searchValue, setSearchValue] = useState('');

  const searchedItems = useMemo(() => {
    const branchData =
      contactUsData ?? landingData?.clubLinkBranchInfoViewModels;
    return branchData.filter((item) => item.branchName.includes(searchValue));
  }, [searchValue, contactUsData]);

  return (
    <StyledDiv pt={12}>
      <SearchInput searchValue={searchValue} setSearchValue={setSearchValue} />
      <StyledDiv mt={8}>
        {searchedItems &&
          searchedItems.map((item, index) => (
            <StyledDiv key={index} mb={5}>
              <ListItem mt={5} key={item.branchName} branchData={item}>
                {item.branchName}
              </ListItem>
            </StyledDiv>
          ))}
      </StyledDiv>
    </StyledDiv>
  );
};

export default Branches;
